import React from 'react'
import Link from 'gatsby-link'
import './index.scss'

const BlogOverviewItem = ({ blog }) => {
  return (
    <div className="blog-overview-item">
      <div className="blog-overview-item__container">
        {
          blog.backgroundImage
          ? <div className="blog-overview-item__image">
            <img src={blog.backgroundImage} />
          </div>
          : <div className="blog-overview-item__image-placeholder"></div>
        }
        <div className="blog-overview-item__content">
          <span>{blog.tag}</span>
          <h3>{blog.headline}</h3>
          <h4>{blog.subheadline}</h4>
          {blog.readingTime ? (
            <div className="blog-overview-item__reading-time">
              {blog.readingTime} Min. lesen
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <Link to={blog.link} />
    </div>
  )
}

export default BlogOverviewItem
